"use client";
import {
  Heading,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Box,
  Text,
  SimpleGrid,
} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {TEXT_VARIANTS} from "@/theme/components/text";

type TableDataProps = {
  heading?: string;
  text?: string;
  columns: string[];
  data: {
    feature: string;
    [key: string]: string;
  }[];
};

const ComparisonTable = (props: TableDataProps) => {
  const {heading, text, columns, data} = props;
  const headingVariant = useSectionHeadingVariant();
  return (
    <Stack spacing={8}>
      {heading && (
        <Heading as="h2" variant={headingVariant} textAlign={"center"}>
          {heading}
        </Heading>
      )}
      {text && (
        <Text variant={TEXT_VARIANTS.BODY2} textAlign={"center"}>
          {text}
        </Text>
      )}

      {/* ✅ Desktop Table */}
      <TableContainer display={{base: "none", md: "block"}} boxShadow={"xl"}>
        <Table borderColor={"rgb(237,242,247)"} borderWidth={"2px"} variant={"striped"}>
          <Thead>
            <Tr>
              <Th color="black" fontSize="24px" py={6} textTransform={"none"}>
                Feature
              </Th>
              {columns.map((column, index) => (
                <Th
                  key={index}
                  color="black"
                  fontSize="24px"
                  py={6}
                  textTransform={"none"}
                >
                  {column}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {data.map((item, index) => (
              <Tr key={index}>
                <Td fontWeight={600}>{item.feature}</Td>
                {columns.map((column, colIndex) => (
                  <Td key={colIndex}>{item[column]}</Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>

      <Stack display={{base: "flex", md: "none"}} spacing={4}>
        {data.map((item, index) => (
          <Box key={index} p={4} borderWidth="1px" borderRadius="md" boxShadow="md">
            <Text fontSize="lg" fontWeight="bold" mb={2}>
              {item.feature}
            </Text>
            <SimpleGrid columns={{base: 1, sm: 2}} spacing={3}>
              {columns.map((column, colIndex) => (
                <Box key={colIndex}>
                  <Text fontSize="md" fontWeight="bold" color="text.100">
                    {column}
                  </Text>
                  <Text mt={1} p={2} bg="gray.100" borderRadius="md" fontSize="md">
                    {item[column]}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default ComparisonTable;
